module.exports = __webpack_public_path__ + "img/sherrer-paineis-2.03965f83.jpeg";